const AVATAR_COLORS = [
  "#2563eb",
  "#7c3aed",
  "#be185d",
  "#0f766e",
  "#b45309",
  "#dc2626",
  "#0e7490",
  "#4f46e5",
  "#15803d",
  "#c026d3",
];

export function avatarColor(value = "") {
  let hash = 2166136261;

  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }

  return AVATAR_COLORS[(hash >>> 0) % AVATAR_COLORS.length];
}
